import { DefaultLoadable } from '@apoly-42/material-ui';

const LoadPharmacyShopLoadable = DefaultLoadable({
  loader: () => import('../../routes/PharmacyShopRoutes.js'),
});

export default LoadPharmacyShopLoadable;
